export default __webpack_public_path__ + "static/media/success-icon.5e04dc79.svg";